import React, { ReactNode, useEffect, useState } from "react";
import { Button, Dialog, Grid, Typography } from "@material-ui/core";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import {
  UserDialogActions,
  UserDialogContent,
  UserDialogTitle,
  useUserDialogStyle,
} from "../../commons/dialog/UserDialog";
import BookingCreate from "./BookingCreate";
import { Booking } from "../booking.model";
import { Moment } from "moment";
import { ListedUser } from "../../users/listedUser.model";

type Props = {
  open: boolean;
  booking: Booking;
  textBtn?: string;
  iconBtn?: ReactNode;
  showUserSelect?: boolean;
  onClose: () => void;
  onCreate: (booking: Booking) => void;
  onChangeTime?: (
    begin: Moment,
    end: Moment,
    title: string,
    isRecurrent?: boolean,
    recurrenceWeekdays?: boolean[],
    recurrenceEndDate?: Date,
  ) => void;
};

const BookingCreateDialog: React.FC<Props> = ({
  open,
  booking,
  textBtn = "Reservar",
  iconBtn = <EventAvailableIcon />,
  showUserSelect,
  onClose,
  onCreate,
  onChangeTime,
}) => {
  const dialogClasses = useUserDialogStyle();
  const [title, setTitle] = useState<string>(booking?.title);
  const [user, setUser] = useState<string>(booking?.user);
  const [attendees, setAttendees] = useState<ListedUser[]>([]);

  const closeDialog = () => {
    onClose();
  };

  useEffect(() => {
    if (open) {
      setTitle(booking?.title as string);
      setAttendees(booking?.attendeesInfo ?? []);
    }
  }, [open]);

  const onSubmit = async (e: any) => {
    e.preventDefault();
    const attendeeIds = attendees.map((a) => a.id);
    onCreate({
      ...booking,
      title: title,
      user,
      attendees: attendeeIds,
      attendeesInfo: attendees,
    } as Booking);
  };

  const handleTitleChange = (title: string) => {
    setTitle(title as string);
  };

  const handleUserChange = (user: string) => {
    setUser(user as string);
  };

  const handleAttendeesChange = (users: ListedUser[]) => {
    setAttendees(users);
  };

  return (
    <>
      {booking && (
        <Dialog
          onClose={closeDialog}
          open={open && !!booking}
          classes={dialogClasses}
        >
          <UserDialogTitle
            id="customized-dialog-title"
            onClose={closeDialog}
            background="owner"
          >
            <Typography variant="h6">Nueva Reserva</Typography>
          </UserDialogTitle>
          <form onSubmit={onSubmit}>
            <UserDialogContent dividers>
              <BookingCreate
                title={title}
                userId={user}
                booking={booking}
                showUserSelect={showUserSelect}
                attendees={attendees}
                onChangeTime={onChangeTime}
                onTitleChange={handleTitleChange}
                onUserChange={handleUserChange}
                onAttendeesChange={handleAttendeesChange}
              />
            </UserDialogContent>
            <UserDialogActions>
              <Grid container justifyContent="flex-end">
                <Grid item xs={4}>
                  <Button
                    autoFocus
                    type="submit"
                    color="secondary"
                    variant="contained"
                    fullWidth
                    endIcon={iconBtn}
                  >
                    {textBtn}
                  </Button>
                </Grid>
              </Grid>
            </UserDialogActions>
          </form>
        </Dialog>
      )}
    </>
  );
};

export default BookingCreateDialog;
